/**
 * XCON Deployment Auto-Add v4
 * Fügt automatisch "Einrichtungsservice" zum Warenkorb hinzu
 * basierend auf Produkten mit dem Tag "deployment".
 *
 * v4: Footer-Refresh entfernt — nur Cart-Items + Subtotal.
 *     Checkout-Button bleibt unangetastet (kein innerHTML-Replace).
 *
 * Staffelpreise (PandaDoc):
 *   1-10 Geräte:  €39/Gerät  (Variant 56973922664792)
 *   11-25 Geräte: €29/Gerät  (Variant 56973923156312)
 *   26-50 Geräte: €19/Gerät  (Variant 56973923287384)
 *   51+ Geräte:   €15/Gerät  (Variant 56973923320152)
 */
(function () {
  'use strict';

  var DEPLOYMENT_PRODUCT_ID = 15669957525848;
  var TIERS = [
    { id: 56973922664792, min: 1, max: 10 },
    { id: 56973923156312, min: 11, max: 25 },
    { id: 56973923287384, min: 26, max: 50 },
    { id: 56973923320152, min: 51, max: Infinity }
  ];
  var ALL_VARIANT_IDS = TIERS.map(function (t) { return t.id; });

  var isOurUpdate = false;
  var syncing = false;
  var syncTimer = null;

  function getTierVariant(count) {
    if (count <= 0) return null;
    for (var i = 0; i < TIERS.length; i++) {
      if (count >= TIERS[i].min && count <= TIERS[i].max) return TIERS[i];
    }
    return TIERS[TIERS.length - 1];
  }

  /**
   * Refresht nur die Cart-Items (nicht den Footer!).
   * Footer-Subtotal wird separat per .js-contents aktualisiert,
   * damit der Checkout-Button nicht zerstört wird.
   */
  function refreshCartSections() {
    return fetch(window.location.pathname + '?sections=main-cart-items,main-cart-footer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();

        isOurUpdate = true;

        // Cart-Items komplett refreshen
        var itemsEl = document.getElementById('main-cart-items');
        if (itemsEl && sections['main-cart-items']) {
          var doc = parser.parseFromString(sections['main-cart-items'], 'text/html');
          var newItems = doc.getElementById('main-cart-items');
          if (newItems) itemsEl.innerHTML = newItems.innerHTML;
        }

        // Footer: NUR .js-contents (Subtotal) ersetzen, Checkout-Button bleibt!
        var footerEl = document.getElementById('main-cart-footer');
        if (footerEl && sections['main-cart-footer']) {
          var doc2 = parser.parseFromString(sections['main-cart-footer'], 'text/html');
          var newJsContents = doc2.querySelector('#main-cart-footer .js-contents');
          var oldJsContents = footerEl.querySelector('.js-contents');
          if (newJsContents && oldJsContents) {
            oldJsContents.innerHTML = newJsContents.innerHTML;
          }
        }
      });
  }

  /**
   * Hauptlogik: Zählt deployment-Produkte und synchronisiert
   * die Deployment-Variante im Warenkorb.
   */
  function syncDeployment() {
    if (syncing) return;
    syncing = true;

    var dataEl = document.getElementById('xcon-deployment-data');
    if (!dataEl) { syncing = false; return; }

    var deploymentCount = parseInt(dataEl.dataset.count, 10) || 0;
    var tier = getTierVariant(deploymentCount);

    fetch('/cart.json')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var deploymentItems = cart.items.filter(function (i) {
          return i.product_id === DEPLOYMENT_PRODUCT_ID;
        });

        if (!tier) {
          if (deploymentItems.length > 0) {
            isOurUpdate = true;
            var updates = {};
            deploymentItems.forEach(function (item) {
              updates[item.variant_id] = 0;
            });
            return fetch('/cart/update.json', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            }).then(function () {
              return refreshCartSections();
            }).then(function () {
              setTimeout(function () { isOurUpdate = false; }, 150);
            });
          }
          return;
        }

        var isCorrect = deploymentItems.length === 1
          && deploymentItems[0].variant_id === tier.id
          && deploymentItems[0].quantity === deploymentCount;

        if (isCorrect) return;

        isOurUpdate = true;
        var updates = {};
        ALL_VARIANT_IDS.forEach(function (vid) {
          updates[vid] = 0;
        });
        updates[tier.id] = deploymentCount;

        return fetch('/cart/update.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          return refreshCartSections();
        }).then(function () {
          setTimeout(function () { isOurUpdate = false; }, 150);
        });
      })
      .catch(function () {
        isOurUpdate = false;
      })
      .finally(function () {
        syncing = false;
      });
  }

  /**
   * Debounced sync — sammelt mehrere Trigger und feuert
   * nur einmal nach 300ms Ruhe.
   */
  function debouncedSync() {
    if (isOurUpdate) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncDeployment, 300);
  }

  /**
   * Fängt Dawn's fetch-Calls ab um Cart-Änderungen zu erkennen.
   */
  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var result = originalFetch.apply(this, arguments);

    if (!isOurUpdate && typeof url === 'string') {
      var isCartChange = url.indexOf('/cart/change') !== -1
        || url.indexOf('/cart/update') !== -1
        || url.indexOf('/cart/add') !== -1;

      if (isCartChange) {
        result.then(function () {
          debouncedSync();
        });
      }
    }

    return result;
  };

  /**
   * MutationObserver: Reagiert auf jede DOM-Änderung im Cart-Bereich.
   */
  function observeCart() {
    var cartEl = document.getElementById('main-cart-items');
    if (!cartEl) return;

    var observer = new MutationObserver(function () {
      debouncedSync();
    });
    observer.observe(cartEl, { childList: true, subtree: true });
  }

  // Bei Seitenladung: Sync + Observer starten
  function init() {
    syncDeployment();
    observeCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
